module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a1-5-167b00a0588fc1dcb0af93beb0a73f49.jpg";